import { all } from 'redux-saga/effects';
import user from './user/sagas';
import indicacao from './indicacao/sagas';
import categorias from './categorias/sagas';
import produtos from './produtos/sagas';
import perguntas from './perguntas/sagas';
import newNotifications from './newNotifications/sagas';
import svas from './svaList/sagas';
import login from './login/sagas';
import recaptcha from './recaptcha/sagas';
import termsAndPolicy from './termsAndPolicy/sagas';
import refreshToken from './refreshToken/sagas';

export default function* rootSaga() {
  return yield all([
    user,
    indicacao,
    categorias,
    produtos,
    perguntas,
    newNotifications,
    svas,
    login,
    recaptcha,
    termsAndPolicy,
    refreshToken,
  ]);
}
